import { observable, action } from "mobx";

const Store = observable(
  {
    entity_groups: null,
    query: "",
    advancedFilter: false,
    page: 0,
    searchValues: true,
    setPage(page) {
      this.page = page;
    },
    setQuery(query) {
      this.query = query;
    },
    setSearchValues(vals) {
      this.searchValues = vals;
    },
    setCount(count) {
      this.count = count;
    },
    toggleAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
    setEntityGroups(entity_groups) {
      this.entity_groups = entity_groups;
    },
  },
  {
    setPage: action,
    setQuery: action,
    setCount: action,
    setSearchValues: action,
    setEntityGroups: action,
  }
);

export default Store;
